{
  "tabs": {
    "chat": "Chat",
    "reminders": "Reminders",
    "calendar": "Calendar",
    "settings": "Settings"
  },
  "common": {
    "cancel": "Cancel",
    "save": "Save",
    "confirm": "Confirm",
    "delete": "Delete",
    "back": "Back",
    "close": "Close",
    "edit": "Edit",
    "search": "Search",
    "all": "All",
    "loading": "Loading...",
    "error": "Something went wrong",
    "notFound": "Not found",
    "tryAgain": "Please try again",
    "retry": "Retry",
    "undo": "Undo",
    "pullToRefresh": "Pull to refresh",
    "justNow": "just now"
  },
  "auth": {
    "welcome": "Welcome to FishMemory",
    "tagline": "Your WhatsApp reminder assistant, now in your pocket.",
    "subtitle": "Your WhatsApp reminder assistant, now in your pocket.",
    "phoneLabel": "Your WhatsApp number",
    "phoneHint": "We'll send a verification code via WhatsApp",
    "invalidPhone": "Please enter a valid phone number",
    "continue": "Continue",
    "enterPhone": "Enter your WhatsApp number",
    "phonePlaceholder": "Phone number",
    "sendCode": "Send Code",
    "verifyTitle": "Verify your number",
    "otpSentTo": "A 6-digit code was sent to {{phone}} via WhatsApp",
    "enterFullCode": "Please enter all 6 digits",
    "invalidOtp": "Invalid code. Please try again.",
    "otpFailed": "Failed to send code. Try again.",
    "otpResent": "Code resent",
    "resendIn": "Resend in {{seconds}}s",
    "resendCode": "Resend code",
    "enterOtp": "Enter the code sent to your WhatsApp",
    "verify": "Verify",
    "resend": "Resend code",
    "wrongNumber": "Wrong number?",
    "backToPhone": "Back to phone",
    "editPhone": "Edit phone number",
    "error": "Error",
    "setupTitle": "Let's set things up",
    "setupSubtitle": "You can always change these later in Settings",
    "namePlaceholder": "Your name",
    "letsGo": "Finish setup",
    "skipForNow": "Skip for now"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Type a message...",
    "inputPlaceholder": "Type a message...",
    "typing": "FishMemory is typing...",
    "online": "Online",
    "connecting": "Connecting...",
    "reconnecting": "Reconnecting...",
    "offline": "Offline",
    "empty": "Start a conversation",
    "emptyHint": "Create reminders, check your schedule, or ask for help.",
    "emptyAction": "Send a sample reminder",
    "actions": "Chat actions",
    "keep": "Keep messages",
    "clearTitle": "Clear chat",
    "clearConfirm": "Delete all messages from this device? This cannot be undone.",
    "clear": "Clear chat",
    "optionSelected": "Selected: {{label}}",
    "sendingSelection": "Sending...",
    "connectionLost": "Reconnecting..."
  },
  "reminders": {
    "title": "My Reminders",
    "active": "Active",
    "today": "Today",
    "thisWeek": "This Week",
    "history": "History",
    "items": "items",
    "emptyTitle": "No reminders yet",
    "emptySubtitle": "Create one from chat and it will show up here.",
    "emptyAction": "Open chat",
    "filterActive": "Active",
    "filterToday": "Today",
    "filterWeek": "This Week",
    "filterHistory": "History",
    "emptyState": "No reminders yet. Start chatting!",
    "swipeDone": "Done",
    "swipeSnooze": "Snooze",
    "swipeDelete": "Delete",
    "search": "Search reminders...",
    "upcoming": "Upcoming",
    "completed": "Completed",
    "overdue": "Overdue",
    "tomorrow": "Tomorrow",
    "synced": "Synced {{value}}",
    "swipeHint": "Swipe a reminder for more actions",
    "showAllCount": "Show all {{count}}",
    "showFewer": "Show fewer",
    "noResults": "No reminders match your search",
    "noResultsHint": "Try a different keyword or clear the search",
    "deleteAllFailed": "Failed to delete all reminders"
  },
  "calendar": {
    "title": "Calendar",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "yesterday": "Yesterday",
    "completed": "done",
    "noEvents": "Nothing scheduled",
    "noEventsSubtitle": "Choose a date to see reminders and calendar events.",
    "googleEvent": "Google Calendar",
    "legendActive": "Active",
    "legendRecurring": "Recurring",
    "legendDone": "Done",
    "legendGoogle": "Google",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "previousYear": "Prev year",
    "nextYear": "Next year",
    "goToToday": "Go to today",
    "all": "All",
    "active": "Active",
    "done": "Done",
    "paused": "Paused"
  },
  "settings": {
    "title": "Settings",
    "profile": "Profile",
    "name": "Display Name",
    "enterName": "Enter your name",
    "language": "Language",
    "uiLanguage": "App language",
    "uiLanguageHelp": "Changes the app UI, calendar labels, and layout direction on this device only.",
    "serverLanguage": "Chat language",
    "serverLanguageHelp": "Changes the language used by server replies and reminder messages for your account.",
    "timezone": "Timezone",
    "currentTimezone": "Current timezone",
    "timezoneHelp": "All reminder times are shown using this timezone.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Save timezone",
    "timezoneSaved": "Timezone updated",
    "detect": "Detect",
    "detectFailed": "Could not detect timezone",
    "autoDetect": "Auto-detect from GPS",
    "notifications": "Notifications",
    "notificationsHelp": "Follow-up reminders control repeated alerts after a reminder is delivered. Device-level notification permissions are still managed in your phone settings.",
    "pushEnabled": "Push Notifications",
    "autoDoneOnFire": "Auto-mark done when fired",
    "autoDoneOnFireDesc": "When off, reminders stay active until you mark them done.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Connected",
    "googleDisconnected": "Not connected",
    "googleConnectedHelp": "New reminders can be synced to your calendar automatically.",
    "googleDisconnectedHelp": "Connect Google Calendar to keep reminders and events aligned.",
    "googleConnectFailed": "Failed to connect Google Calendar",
    "connected": "Connected",
    "disconnected": "Not connected",
    "connect": "Connect",
    "disconnect": "Disconnect",
    "autoSync": "Auto-sync new reminders",
    "autosync": "Auto-sync new reminders",
    "subscription": "Subscription",
    "trialUsed": "Trial: {{used}}/{{total}} used",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialStatus": "Trial available",
    "trialEnds": "Trial ends {{date}}",
    "activeStatus": "Active subscription",
    "expiredStatus": "Subscription expired",
    "unsubscribedStatus": "Not subscribed",
    "about": "About",
    "version": "Version",
    "logout": "Log Out",
    "logoutTitle": "Log Out",
    "logoutConfirm": "Are you sure you want to log out?",
    "noName": "No name set",
    "serverConnection": "Server connection",
    "serverUrl": "Server URL",
    "serverEdit": "Edit",
    "saveReconnect": "Save and reconnect",
    "resetDefault": "Reset default",
    "invalidServerUrlTitle": "Invalid server URL",
    "invalidServerUrlMessage": "Enter a valid http or https server URL, for example https://example.com",
    "uiLanguageChangeFailed": "Failed to change app language. Please try again.",
    "serverLanguageChangeFailed": "Failed to change chat language. Please try again.",
    "timezoneChangeFailed": "Failed to change timezone. Please try again.",
    "autoSyncChangeFailed": "Failed to update auto-sync. Please try again.",
    "nameChangeFailed": "Failed to update display name. Please try again."
  },
  "reminder": {
    "body": "Reminder details",
    "editTime": "Edit Time",
    "rename": "Rename",
    "snooze": "Snooze",
    "snooze15": "Snooze 15 minutes",
    "pause": "Pause",
    "pauseReminder": "Pause reminder",
    "resume": "Resume",
    "resumeReminder": "Resume reminder",
    "skip": "Skip Next",
    "skipOccurrence": "Skip this occurrence",
    "syncGoogle": "Sync to Google",
    "delete": "Delete",
    "deleteTitle": "Delete Reminder",
    "deleteConfirm": "This reminder will be permanently deleted.",
    "deleteRecurringTitle": "Delete Recurring Reminder",
    "deleteRecurringMessage": "Do you want to skip this occurrence or delete the entire series?",
    "deleteThisOccurrence": "Skip This Occurrence",
    "deleteEntireSeries": "Delete Entire Series",
    "done": "Done",
    "markDone": "Mark as done",
    "undo": "Restore",
    "undoPrompt": "Need it active again? Restore it now.",
    "recurring": "Recurring",
    "nextRun": "Next run",
    "oneTime": "One-time",
    "pending": "Pending",
    "sent": "Sent",
    "paused": "Paused",
    "active": "Active",
    "snoozed": "Snoozed",
    "localTime": "Shown in your local time",
    "recurrence": "Recurrence",
    "created": "Created",
    "tags": "Tags",
    "fireCount": "Times fired",
    "actions": "Actions",
    "none": "None",
    "snoozeFailed": "Failed to snooze reminder",
    "pauseFailed": "Failed to pause reminder",
    "resumeFailed": "Failed to resume reminder",
    "skipFailed": "Failed to skip reminder",
    "doneFailed": "Failed to mark reminder as done",
    "undoFailed": "Failed to restore reminder status",
    "deleteFailed": "Failed to delete reminder",
    "rescheduleTitle": "Reschedule?",
    "rescheduleMsg": "This reminder is overdue. Would you like to reschedule it?",
    "reschedule15": "In 15 minutes",
    "reschedule60": "In 1 hour",
    "keepOverdue": "Keep as is"
  },
  "onboarding": {
    "slide1Title": "Welcome to FishMemory",
    "slide1Sub": "Your personal reminder assistant — powered by WhatsApp and built for your pocket.",
    "slide2Title": "Just Chat Naturally",
    "slide2Sub": "Type reminders the way you think: \"Remind me to call mom tomorrow at 3pm\" — we handle the rest.",
    "slide3Title": "Never Miss a Thing",
    "slide3Sub": "Get timely notifications, organize with tags, and stay on top of everything that matters.",
    "getStarted": "Get Started",
    "next": "Next",
    "firstReminderTitle": "Create your first reminder!",
    "firstReminderHint": "Try typing something like:",
    "firstReminderExample": "Remind me to drink water tomorrow at 9 AM",
    "gotIt": "Got it!",
    "notifRationaleTitle": "Stay on Time",
    "notifRationaleBody": "FishMemory needs notifications to remind you on time. You'll only get alerts for reminders you create.",
    "notifRationaleAllow": "Enable Notifications",
    "notifRationaleLater": "Maybe Later",
    "swipeHint": "Swipe right for quick actions →",
    "calendarDragHint": "Drag to expand ↕"
  }
}
